<template>
  <div class="ch-filter-in-detail">
    <bookings-filter class="ma-0 mb-3" :doorlockBookingId="id"></bookings-filter>
    <bookings-list :doorlockBookingId="id"></bookings-list>
  </div>
</template>

<script>
  import BookingsFilter from '@/components/admin/bookings/BookingsFilter';
  import BookingsList from '@/components/admin/bookings/BookingsList';

  export default {
    data() {
      return {
        id: null,
      };
    },
    created() {
      this.id = this.$route.params.id;
    },
    components: {
      BookingsFilter, BookingsList,
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlockBookings.vue